
export type OrderStatus = "pending" | "paid" | "suspended" | "processing" | "confirming" | "completed";

/**
 * Class representing properties to check if a WooCommerce order has been paid.
 */
export class Order {
    public readonly id: number; // the unique ID for this order
    public readonly nonce: string; // a nonce to authenticate REST API requests
    public readonly status: OrderStatus;
    public readonly status_wc: string; // WooCommerce status string (without wc- prefix)
    public readonly total: number; // total order amount (in shop currency)

    constructor() {
    }

    // ################################################################
    // ###################### PRIVATE FUNCTIONS #######################

}
